import React, { useState, ReactNode } from "react";
import { Popover, Badge } from "antd";
import { FilterOutlined } from "@ant-design/icons";

interface FiltersPopupWrapperProps {
    children: ReactNode;
    buttonText?: string;
    placement?: "top" | "bottom" | "left" | "right" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
    activeFiltersCount?: number;
}

const FiltersPopupWrapper: React.FC<FiltersPopupWrapperProps> = ({
    children,
    buttonText = "Filters",
    placement = "bottomRight",
    activeFiltersCount = 0
}) => {
    const [open, setOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    const buttonStyle: React.CSSProperties = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        borderRadius: '8px',
        border: open ? '1px solid #1890ff' : '1px solid #e0e0e0',
        background: open
            ? 'linear-gradient(135deg, #e6f4ff 0%, #f0f7ff 100%)'
            : isHovered
                ? 'linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)'
                : '#ffffff',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 500,
        color: open ? '#1890ff' : '#595959',
        boxShadow: open
            ? '0 2px 8px rgba(24, 144, 255, 0.15)'
            : isHovered
                ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                : '0 1px 3px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.2s ease-in-out',
        userSelect: 'none',
    };

    const iconStyle: React.CSSProperties = {
        fontSize: '16px',
        color: open ? '#1890ff' : '#8c8c8c',
        transition: 'color 0.2s ease-in-out',
    };

    return (
        <Popover
            content={
                <div style={{ minWidth: '300px', maxWidth: '600px' }}>
                    {children}
                </div>
            }
            title="Filters"
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
            placement={placement}
        >
            <Badge count={activeFiltersCount} size="small" offset={[-5, 5]}>
                <div
                    style={buttonStyle}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <FilterOutlined style={iconStyle} />
                    <span>{buttonText}</span>
                </div>
            </Badge>
        </Popover>
    );
};

export default FiltersPopupWrapper;
